<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12 col-sm-12 mb-3">
        <div class="card p-4">
          <div class="media">
            <div class="avatar-sm mr-3">
              <span
                class="
                  avatar-title
                  rounded-circle
                  bg-light
                  text-primary
                  border-primary
                  font-size-22
                "
              >
                <i class="bx bx-search bx-md"></i>
              </span>
            </div>
            <div class="media-body">
              <h5 class="mt-3">{{ $t("education.education-search") }}</h5>
            </div>
          </div>
          <div class="row mt-5 pb-3">
            <div class="col-sm-12 text-right">
              <div class="input-group pb-3">
                <input
                  id="search"
                  type="text"
                  class="form-control"
                  v-model="searchKey"
                  placeholder="nama, kampus, prodi.."
                  aria-describedby="search"
                  @keyup.enter="SearchNama"
                />
                <div class="input-group-prepend">
                  <button
                    id="search"
                    class="input-group-text bg-primary text-white"
                    @click="SearchNama"
                  >
                    <i class="bx bx-search-alt search-icon"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="col-sm-12 font-weight-bold">
              <table v-if="id_target && target.length != 0">
                <tr>
                  <td>Target Profile</td>
                  <td>:</td>
                  <td>{{ target.title }}</td>
                </tr>
              </table>
            </div>
          </div>
          <div
            v-if="error !== '' && !loading"
            class="row mt-5 mb-5 pb-4 mx-auto"
          >
            <div class="text-center">
              <span class="text-secondary">{{ error }}</span>
            </div>
          </div>
          <div v-if="loading" class="row mt-4 mx-auto">
            <div class="text-center p-5">
              <div class="spinner-border text-secondary" role="status"></div>
              <p>{{ $t("education.search-data") }} ..</p>
            </div>
          </div>
          <div
            v-if="mhs_result.length < 2 && !loading && search"
            class="row mt-5 mb-5 pb-4 mx-auto"
          >
            <div class="text-center">
              <span class="text-secondary">{{ $t("all.dnf") }}</span>
            </div>
          </div>
          <div>
            <div
              class="row mt-4"
              v-if="mhs_result.length > 1 && !loading && error == ''"
            >
              <div class="col-sm-12">
                <table class="table table-bordered px-2">
                  <thead>
                    <tr>
                      <td width="5%" class="text-center"><b>No</b></td>
                      <td>
                        <b>{{ $t("education.data-mahasiswa") }}</b>
                      </td>
                      <td>
                        <b>{{ $t("education.action") }} </b>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(mhs, index) in mhs_result" :key="index">
                      <td class="text-center">
                        {{ index + 1 }}
                      </td>
                      <td>
                        <a
                          :href="mhs['website-link']"
                          target="_blank"
                          class="text-primary"
                        >
                          {{ mhs.text }}</a
                        >
                      </td>
                      <td>
                        <router-link
                          :to="{
                            name: 'detail-mahasiswa',
                            params: { id: mhs.text },
                          }"
                          target="_blank"
                          ><b-button class="btn-sm" variant="secondary">
                            {{ $t("education.view-detail") }}
                          </b-button></router-link
                        >
                        <b-button
                          v-if="id_target && target.length != 0"
                          class="btn-sm ml-2"
                          variant="secondary"
                          @click="addToTarget(mhs.text)"
                        >
                          {{ $t("education.add-target") }}
                        </b-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Vue from "vue";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import moment from "moment";
import EducationService from "@/helpers/education.service";
import PhoneService from "@/helpers/phone.service.js";
import TargetService from "@/helpers/target-profile.service";
import SocmedService from "@/helpers/socmed.service";
import GroupService from "@/helpers/group.service";
import Swal from "sweetalert2";

export default {
  page: {
    title: "Education Search",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: this.$t("education.education-search"),
          active: true,
        },
      ],
      link: "https://pddikti.kemdikbud.go.id/",
      loadingGrup: false,
      loading: false,
      loadinglist: false,
      search: false,
      searchKey: "",
      mhs_result: "",
      error: "",
      is_spam: "",
      search: false,
      title: this.$t("education.education-search"),
      id_target: this.$route.query.target,
      target: [],
      detailMhs: [],
    };
  },
  methods: {
    SearchNama() {
      if (this.searchKey != "") {
        this.error = "";
        this.search = true;
        this.loading = true;
        this.mhs_result = [];
        var data = {
          nama: this.searchKey,
        };
        EducationService.SearchNamaMahasiwa(data)
          .then((response) => {
            this.mhs_result = response.data.output;
            this.loading = false;
          })
          .catch((err) => {
            console.log(err);
            this.search = false;
            this.loading = false;
            if (err.response.status == 500) {
              this.error = "Internal server Error";
            } else if (err.response.status == 404) {
              this.error = "Server Not Found";
            }
          });
      }
    },
    getNama(mhs) {
      if (this.searchKey != "") {
        this.search = true;
        this.loading = true;
        this.mhs = [];
        var data = {
          nama_mahasiswa: mhs,
        };
        EducationService.getMahasiwa(data)
          .then((response) => {
            const res = response.data.output.dataumum;
            this.mhs = res;
            this.loading = false;
          })
          .catch((err) => {
            console.log(err);
            this.search = false;
            this.loading = false;
          });
      }
    },

    addToTarget(id) {
      this.getDetailEdu(id);
    },

    addEdu() {
      let data = {
        id_target: this.id_target,
        nipd: this.detailMhs.nipd,
        nm_pd: this.detailMhs.nm_pd,
        namapt: this.detailMhs.namapt,
        namajenjang: this.detailMhs.namajenjang,
        namaprodi: this.detailMhs.namaprodi,
        jk: this.detailMhs.jk,
        reg_pd: this.detailMhs.reg_pd,
        mulai_smt: this.detailMhs.mulai_smt,
        nm_jns_daftar: this.detailMhs.nm_jns_daftar,
        nm_pt_asal: this.detailMhs.nm_pt_asal,
        nm_prodi_asal: this.detailMhs.nm_prodi_asal,
        ket_keluar: this.detailMhs.ket_keluar,
        tgl_keluar: this.detailMhs.tgl_keluar,
        no_seri_ijazah: this.detailMhs.no_seri_ijazah,
        sert_prof: this.detailMhs.sert_prof,
        link_pt: this.detailMhs.link_pt,
        link_prodi: this.detailMhs.link_prodi,
      };
      console.log(data);
      EducationService.SaveEducation(data)
        .then((response) => {
          Vue.swal({
            position: "top-end",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.$router.push({
            name: "project-overview",
            params: { id: this.id_target },
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getDetailEdu(id) {
      var data = {
        nama_mahasiswa: id,
      };
      console.log(data);
      EducationService.getMahasiwa(data)
        .then((response) => {
          this.detailMhs = response.data.output.data_umum;
          this.addEdu();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getTargetProfile() {
      if (this.id_target != "" && this.id_target != null) {
        TargetService.getDetailTarget(this.id_target)
          .then((response) => {
            let data = {
              title: response.data.data.title,
              id: response.data.data.id_target,
            };
            this.target = data;
          })
          .catch((err) => {
            console.log("err ", err);
          });
      }
    },

    formatDate(value) {
      return moment(value).format("dddd, YYYY-MM-DD hh:mm");
    },
  },
  mounted() {
    this.getTargetProfile();
  },
};
</script>

<style scoped>
.loading {
  padding-top: 20%;
  padding-bottom: 20%;
}
</style>